import { useNavigate } from 'react-router-dom';
import { useCalendar } from '../CalendarContext/CalendarContext';
import { CalendarView } from '../calendarWrapper/CalendarWrapper';
import TTLLocalStorage, { WEBOOK_SAVED_CURRENT_DATE } from '../../utils/TTLLocalStorage';

export const useOpenDayInAgenda = () => {
  const { setCalendarView, setCurrentDate } = useCalendar();
  const navigate = useNavigate();

  return (date: string) => {
    setCalendarView(CalendarView.AREAS);
    setCurrentDate(date);
    TTLLocalStorage.setItem(WEBOOK_SAVED_CURRENT_DATE, date, 86400000 * 7);
    // Through the router, so the :startDate param (re-read by CalendarContext on a view change) is this date.
    navigate(`/dashboard/calendar/${date}`);
  };
};
